import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20anime%20style%20illustration%20with%20multiple%20popular%20anime%20characters%20silhouettes%2C%20dramatic%20warm%20orange%20and%20red%20sunset%20sky%2C%20cinematic%20composition%2C%20anime%20collage%20banner%2C%20vibrant%20colors%2C%20clean%20artistic%20rendering%2C%20horizontal%20format&width=1800&height=900&seq=hero-anime-bg&orientation=landscape"
          alt="91动漫 - 海量动漫资源在线观看"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-6 whitespace-nowrap">
          <i className="ri-fire-line"></i>
          2024夏季新番热播中
        </span>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white text-center leading-tight max-w-3xl">
          随时随地，畅享
          <span className="text-primary-400">动漫世界</span>
        </h1>

        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/80 text-center max-w-xl leading-relaxed">
          汇聚海量国漫、日漫、美漫资源，支持高清免费在线播放。热血冒险、恋爱日常、奇幻玄幻，你想要的这里都有。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/riman"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即追番
          </Link>
          <Link
            to="/category/guoman"
            className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-sparkling-line"></i>
            国漫精选
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10 md:mt-14">
          {[
            { num: '10万+', label: '动漫资源' },
            { num: '500万+', label: '活跃用户' },
            { num: '4.9', label: '用户评分' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.num}</div>
              <div className="text-xs text-white/60 mt-1 whitespace-nowrap">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}